import React, { useEffect, useState } from "react";
import axios from "axios";
import "./TempleTimingsInfo.css";

export default function TempleTimingsInfo() {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      // .get("http://localhost/myapp/api/fetch_timings.php")
      .get("https://peralassery.cubixsystems.com/myapp/api/fetch_timings.php")
      .then((res) => {
        const enabledData = res.data.filter(
          (item) => Number(item.status) === 1
        );
        setData(enabledData);
      });
  }, []);

  return (
    <div className="temple-timings-container" >
      {/* <h2 className="main-title">🛕 Temple Timings</h2> */}

      {data.length === 0 && (
        <p style={{ textAlign: "center" }}>Loading...</p>
      )}
      <div className="">
        <div className="row">
          <div className="col-md-12">
            {data.map((row) => (
              <div className="timing-card" key={row.id} >
                <h3 className="heading-title">{row.heading}</h3>
                <div className="row">
                  <div className="col-md-12">
                    {Array.isArray(row.morning) && row.morning.length > 0 && (
                      <div className="time-section morning">
                        <h4>ശ്രീ സുബ്രഹ്മണ്യസ്വാമി ക്ഷേത്രം</h4>
                        {row.morning.map((m) => (
                          <p key={m.id} style={{color:'maroon',background:'white',marginBottom:'10px',boxShadow:'0px 0px 5px black inset',fontSize:'15px',lineHeight:'16pt',padding:'15px'}}>{m.time_value}</p>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="col-md-12">
                    {Array.isArray(row.evening) && row.evening.length > 0 && (
                      <div className="time-section evening">
                        <h4>ശ്രീ അയ്യപ്പ ക്ഷേത്രം</h4>
                        {row.evening.map((e) => (
                          <p key={e.id} style={{color:'maroon',background:'white',marginBottom:'10px',boxShadow:'0px 0px 5px black inset',fontSize:'15px',lineHeight:'16pt',padding:'15px',width:'100%'}}>{e.time_value}</p>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
